import React from 'react';
import Grid from '@material-ui/core/Grid';
import Menu from './components/Menu';
import Header from './components/Header';
import ReCaptchaNotice from '../common/ReCaptchaNotice';

const PrivateLayout = ({ children }) => {
  return (
    <Grid container className="layout-private__container">
      <Grid item xs={2} className="component-menu">
        <nav>
          <Menu />
        </nav>
      </Grid>
      <Grid item xs={10} className="layout-private__main">
        <header className="component-header">
          <Header />
        </header>
        <article className="layout-private__content">{children}</article>
        <footer className="layout-private__footer">
          <ReCaptchaNotice />
        </footer>
      </Grid>
    </Grid>
  );
};

export default PrivateLayout;
